import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";

export default function InvitePublic() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/invites/public/${token}`)
      .then(({ data }) => setData(data))
      .catch(() => setError("Invite not found or expired"));
  }, [token]);

  if (error)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-red-600" data-testid="invite-error">
        {error}
      </div>
    );
  if (!data)
    return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-400">Loading...</div>;

  const { invite, qr_code_base64 } = data;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 text-brand-navy p-6" data-testid="invite-public-page">
      <div className="max-w-sm w-full border border-slate-200 bg-white p-8 text-center space-y-6">
        <img src="/brand/radish-logo.png" alt="Radish Technologies" className="h-8 w-auto mx-auto" data-testid="invite-brand-logo" />
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-cyan">Visit Invitation</span>
        <h1 className="text-2xl font-bold uppercase tracking-tight text-brand-navy">{invite.visitor_name}</h1>
        <p className="text-slate-500 text-sm">
          Hosted by <span className="text-brand-navy font-medium">{invite.host_name}</span> for {invite.purpose}
        </p>
        <img
          src={`data:image/png;base64,${qr_code_base64}`}
          alt="Visit QR code"
          className="mx-auto w-48 h-48"
          data-testid="invite-qr-code"
        />
        <p className="text-xs text-slate-400 uppercase tracking-widest">Present this QR code at the gate</p>
        <div className="text-left text-sm border-t border-slate-200 pt-4 space-y-1">
          <p>
            <span className="text-slate-400">Status:</span> <span className="uppercase font-bold text-brand-navy">{invite.status}</span>
          </p>
          {invite.scheduled_start && (
            <p>
              <span className="text-slate-400">Scheduled:</span>{" "}
              <span className="text-slate-700">
                {new Date(invite.scheduled_start).toLocaleString()}
                {invite.scheduled_end && ` – ${new Date(invite.scheduled_end).toLocaleTimeString()}`}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
